import useFetchLayoutServiceRecommendedVehicles from '../../../core/apiHooks/useFetchLayoutServiceRecommendedVehicles';
import { useAppSelector } from '../../../core/utils';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { selectDealer } from '../../../core/reducers/dealer';
const useFetchRecommendedVehicles = ({ carsSedansPrecedence, suvsTrucksPrecedence, }, shouldFetch = true) => {
    const { dealerCode } = useAppSelector(selectDealer);
    const { modelKey, modelYear } = useAppSelector(selectCurrentVehicle);
    const selections = {
        modelKey,
        modelYear,
        dealerCode,
    };
    return useFetchLayoutServiceRecommendedVehicles(selections, carsSedansPrecedence, suvsTrucksPrecedence, shouldFetch);
};
export default useFetchRecommendedVehicles;
